export default __webpack_public_path__ + "static/media/minus.960867b3.svg";